import React from 'react';
import MediaComponent from './activity/MediaComponent';
import plusCricle from '../assets/images/model/plus-addmedia.svg';
import image from '../assets/images/model/image-icon.svg';
import vidoe from '../assets/images/model/video_icon.svg';
import audio from '../assets/images/model/audio-icon.svg';
import DynamicInput from './atoms/DynamicInput';
import plus from '../images/plus_color.svg';

const ActivityMedia = ({
  handleMediaUpload = () => {},
  setOpenMedia,
  setMediaList,
  openMedia,
  mediaList,
  activity,
  setDesc,
  elRef,
  mode,
}) => {
  return (
    <div>
      {mode !== 'save' && (
        <div className='description-input-wrapper' style={{ alignItems: 'flex-start' }}>
          <img
            src={plus}
            ref={elRef}
            alt='plus'
            className='cursor'
            onClick={() => setOpenMedia(true)}
          />
          <DynamicInput
            placeHolder={'Write instructions or use plus for media (optional)'}
            onChange={setDesc}
            value={activity}
            name={'desc'}
          />
        </div>
      )}
      <div className='custom_droup_down'>
        {openMedia && (
          <ul style={{ left: '0px', width: '168px' }}>
            <li
              onClick={() => {
                setMediaList((prev) => [...prev, { type: 'image', url: '' }]);
                setOpenMedia(false);
              }}
            >
              <div>
                <img src={image} alt='' />
                <img className='plus-image' src={plusCricle} alt='' />
              </div>
              <div className='img-audio-vid'>Image</div>
            </li>
            <li
              onClick={() => {
                setMediaList((prev) => [...prev, { type: 'video', url: '' }]);
                setOpenMedia(false);
              }}
            >
              <div>
                <img src={vidoe} alt='' />
                <img className='plus-image' src={plusCricle} alt='' />
              </div>

              <div className='img-audio-vid'>Video</div>
            </li>
            <li
              onClick={() => {
                setMediaList((prev) => [...prev, { type: 'audio', url: '' }]);
                setOpenMedia(false);
              }}
            >
              <div>
                <img src={audio} alt='' />
                <img className='plus-image' src={plusCricle} alt='' />
              </div>

              <div className='img-audio-vid'>Audio</div>
            </li>
          </ul>
        )}
      </div>
      {mediaList.map((mediaItem, index) => (
        <MediaComponent
          key={index}
          media={mediaItem}
          isEditing={true}
          onSuccess={(fileUrl, alt, attribution) => {
            handleMediaUpload(fileUrl, index);
          }}
        />
      ))}
    </div>
  );
};

export default ActivityMedia;
